import { buildTheme } from './buildTheme'

type TAdvancedColors = FirstParam<typeof buildTheme>['advancedColors']

/**
 * this function (mostly) safely turns the *ugly* BE stringified advanced colors setting
 * into a **beautiful** object that can be used to build up a perfect theme for the company
 */
export const validateAdvancedColors = (configString: unknown): TAdvancedColors => {
  try {
    if (typeof configString !== 'string') return {}

    const config = JSON.parse(configString)

    if (typeof config !== `object`) return {}
    if (Array.isArray(config)) return {}

    return config
  } catch (error) {
    return {}
  }
}
